export const DEFAULT_STEPS = [

  {
    id:23,
    stepName:'USCIS Content',
    stepDescription:'USCIS Content',
    layoutCode:'USCIS_CONTENT',
    sequenceNo:120.0,
    stepTypeId:182,
    isAttorneyVisible: 1,
    isBeneficiaryVisible: 1,
    isPetitionerVisible: 1,
    uiLocked: true,
    actionNotifyFlag : [{
      isPetnrAtrnyActionable: 1,
      isBeneficiaryNotify: 1,
      isAttorneyNotify: 1,
      isPetitionerNotify: 1
    },{
      isBeneficiaryActionable: 0,
      isBeneficiaryNotify: 0,
      isAttorneyNotify: 0,
      isPetitionerNotify: 0
    }]
  
    },
    {
      id:12,
      stepName:'Generate Letters',
      stepDescription:'Generate Letters',
      layoutCode:'FILL_FORM',
      sequenceNo:120.0,
      stepTypeId:182,
      isAttorneyVisible: 1,
      isBeneficiaryVisible: 1,
      isPetitionerVisible: 1,
      uiLocked: true,
      actionNotifyFlag : [{
        isPetnrAtrnyActionable: 1,
        isBeneficiaryNotify: 1,
        isAttorneyNotify: 1,
        isPetitionerNotify: 1
      },{
        isBeneficiaryActionable: 0,
        isBeneficiaryNotify: 0,
        isAttorneyNotify: 0,
        isPetitionerNotify: 0
      }]
    
      },
  {
      id: 20,
      stepTypeId: 182,
      sequenceNo: 2,
      layoutCode: 'REVIEW_PETITION',
      stepName: 'Review Petition',
      stepDescription: 'Review Petition',
      isAttorneyVisible: 1,
      isBeneficiaryVisible: 1,
      isPetitionerVisible: 1,
      uiLocked: true,
      actionNotifyFlag : [{
        isPetnrAtrnyActionable: 1,
        isBeneficiaryNotify: 1,
        isAttorneyNotify: 1,
        isPetitionerNotify: 1
      },{
        isBeneficiaryActionable: 0,
        isBeneficiaryNotify: 0,
        isAttorneyNotify: 0,
        isPetitionerNotify: 0
    }]  
},{
    id: 14,
    stepTypeId: 182,
    sequenceNo: 3,
    layoutCode: 'PRINT_PETITION',
    stepName: 'Print Petition',
    stepDescription: 'Print Petition',
    isAttorneyVisible: 1,
    isBeneficiaryVisible: 1,
    isPetitionerVisible: 1,
    uiLocked: true,
    actionNotifyFlag : [{
        isPetnrAtrnyActionable: 1,
        isBeneficiaryNotify: 1,
        isAttorneyNotify: 1,
        isPetitionerNotify: 1
      },{
        isBeneficiaryActionable: 0,
        isBeneficiaryNotify: 0,
        isAttorneyNotify: 0,
        isPetitionerNotify: 0
    }]     
},{
    id: 22,
    stepTypeId: 200,
    sequenceNo: 4,
    layoutCode: 'SUBMIT_FEES',
    stepName: 'Submit Petition',
    stepDescription: 'Submit Petition',
    isAttorneyVisible: 1,
    isBeneficiaryVisible: 1,
    isPetitionerVisible: 1,
    uiLocked: true,
    actionNotifyFlag : [{
        isPetnrAtrnyActionable: 1,
        isBeneficiaryNotify: 1,
        isAttorneyNotify: 1,
        isPetitionerNotify: 1
      },{
        isBeneficiaryActionable: 0,
        isBeneficiaryNotify: 0,
        isAttorneyNotify: 0,
        isPetitionerNotify: 0
      }]    
},{
  id: 13,
  stepTypeId: 182,
  sequenceNo: 1,
  layoutCode: 'GET_RECEIPT',
  stepName: 'Get Receipt',
  stepDescription: 'Get Receipt',
  isAttorneyVisible: 1,
  isBeneficiaryVisible: 1,
  isPetitionerVisible: 1,
  uiLocked: true,
  actionNotifyFlag : [{
    isPetnrAtrnyActionable: 1,
    isBeneficiaryNotify: 1,
    isAttorneyNotify: 1,
    isPetitionerNotify: 1
  },{
    isBeneficiaryActionable: 0,
    isBeneficiaryNotify: 0,
    isAttorneyNotify: 0,
    isPetitionerNotify: 0
  }]  
}];
